// src/containers/UpdatePrivateVehicle/index.tsx
import React from 'react';
import { Drawer } from '../../components';
import UpdatePrivateVehicleForm from '../../components/molecules/configuration/privateVehicles/updateVehicles3';
// import { UpdatePrivateVehicleForm } from '../../components/molecules/configuration/privateVehicles/updateVehicle';
import { useStyles } from '../../services/material-ui';

const UpdatePrivateVehicle: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <UpdatePrivateVehicleForm />
      </main>
    </div>
  );
};

export default UpdatePrivateVehicle;
